import React from 'react'
import styled from 'styled-components'
import { StandardColumn } from '../../../../components/StandardPage'
import { STATUS_LABELS, TYPE_LABELS } from './constants'
import { PurchaseOrder } from './types'
import { StatusBadge } from './style'

const Description = styled.div`
  color: #969696;
  font-size: 0.65rem;
`

export const purchaseOrderScreenKey = 'purchase_order'

const formatDate = (value: string | null) => {
  if (!value) return '-'
  return new Date(value).toLocaleDateString('pt-BR')
}

const formatCurrency = (value: string | number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value))

export const buildPurchaseOrderColumns = (): StandardColumn<PurchaseOrder>[] => [
  { id: 'code', label: 'Código' },
  {
    id: 'title',
    label: 'Título',
    cell: (order) => (
      <>
        {order.title}
        {order.description && <Description>{order.description}</Description>}
      </>
    ),
  },
  {
    id: 'supplier',
    label: 'Fornecedor',
    accessor: (order) => order.SupplierCompany?.companyName ?? '',
  },
  {
    id: 'type',
    label: 'Tipo',
    accessor: (order) => TYPE_LABELS[order.type] || order.type,
  },
  {
    id: 'status',
    label: 'Status',
    accessor: (order) => STATUS_LABELS[order.status] || order.status,
    cell: (order) => <StatusBadge $status={order.status}>{STATUS_LABELS[order.status] || order.status}</StatusBadge>,
  },
  {
    id: 'createdAt',
    label: 'Aberto em',
    accessor: (order) => order.createdAt,
    cell: (order) => <>{formatDate(order.createdAt)}</>,
    exportValue: (order) => formatDate(order.createdAt),
  },
  {
    id: 'deadline',
    label: 'Prazo',
    accessor: (order) => order.deadline,
    cell: (order) => <>{formatDate(order.deadline)}</>,
    exportValue: (order) => formatDate(order.deadline),
  },
  {
    id: 'totalValue',
    label: 'Valor',
    accessor: (order) => Number(order.totalValue),
    cell: (order) => <>{formatCurrency(order.totalValue)}</>,
    exportValue: (order) => formatCurrency(order.totalValue),
  },
]
